import DynamicImage from '@/components/commons/dynamic-image';
import { AboutUsElementDataType } from '@/components/sections/builder/elements/body/about-us/type';
import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';

export default function ElementContentAboutUs({ element }: ElementProps) {
  const content = element.data as AboutUsElementDataType;
  const childs = element.childs;

  return (
    <>
      <section className='color-scheme-about-us mx-auto flex w-full  duration-100 md:container'>
        <div className='padding-about-us grid grid-cols-1 items-start gap-5 lg:grid-cols-2 lg:items-center lg:gap-10'>
          <DynamicImage
            src={content.image as string}
            alt='Store image'
            width={600}
            height={400}
            className='w-full rounded-lg'
            sizes='100vw'
          />
          <div className='flex flex-col gap-6'>
            {(childs || []).map((child) => (
              <WrapperChild
                child={{
                  ...child,
                  parentData: content,
                }}
                parentType={element.type}
                key={child.id}
              />
            ))}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .color-scheme-about-us {
            background-color: ${content.colorSchemeSection?.background};
            color: ${content.colorSchemeSection?.text};
          }
          .padding-about-us {
            padding-top: ${content.padding?.top || 0}px;
            padding-bottom: ${content.padding?.bottom || 0}px;
            padding-left: ${content.padding?.left || 0}px;
            padding-right: ${content.padding?.right || 0}px;
          }
          @media (max-width: 768px) {
            .padding-about-us {
              padding-left: 16px;
              padding-right: 16px;
            }
          }
        `}
      </style>
    </>
  );
}
